import { deepObjFind } from 'app/pages/loanApplication/LoanApplication.utils';
import _ from 'lodash';

import { LoanApplicationTabName } from 'constants/loanApplication';

import { showMessageAction } from 'store/global/actions';
import {
  setFollowNavigationInProgress,
  startFollowingAction,
  stopFollowingAction,
} from 'store/presence/actions';
import { selectFollowedUser } from 'store/presence/selectors';

import { selectLoanApplicationControlUI } from '../selectors/controlUI.selectors';

import { setActiveTabWithNavigationAction } from './controlUI.actions';

export const startFollowingWithNavigationAction =
  ({ userId, connectionId, applicationId }) =>
  (dispatch, getState) => {
    dispatch(startFollowingAction({ userId, connectionId }));

    const state = getState();
    const followedUser = selectFollowedUser(state);

    if (_.isNil(followedUser?.tab) || _.isNil(applicationId)) {
      return;
    }

    const targetTabName = followedUser.tab;
    const tabKey = _.invert(LoanApplicationTabName)[targetTabName];

    if (!_.isNil(tabKey)) {
      const { availableTabs } = selectLoanApplicationControlUI(state);

      if (!deepObjFind(availableTabs, tabKey)) {
        dispatch(stopFollowingAction());
        dispatch(
          showMessageAction({
            message: `Cannot follow — you don't have access to ${targetTabName}`,
            variant: 'info',
          }),
        );

        return;
      }
    }

    setFollowNavigationInProgress(true);
    dispatch(
      setActiveTabWithNavigationAction({
        activeTab: targetTabName,
        activeSubtab: followedUser.subtab,
        applicationId,
        entityId: followedUser.entityId,
        section: followedUser.sectionId,
        subsection: followedUser.subsection,
      }),
    );
    setFollowNavigationInProgress(false);
  };
